import { useTLang } from 'intl/intl';

export function usePhoneCallBtnLang() {
  return {
    callUser: useTLang({ id: 'showPhoneButton.label' }),
  };
}
